import { makeImmutable } from "../core/makeImmutable";
import { PPrice } from "./PPrice";
export class PProductInstanceVariant {
    constructor(params) {
        this.domain = params.domain;
        this.name = params.name;
        this.localizationProvider = params.localizationProvider;
        this.menuSectionId = params.menuSectionId;
        makeImmutable(this);
    }
    get id() {
        return this.domain.id;
    }
    get productTypeId() {
        return this.domain.productType.id;
    }
    eq(other) {
        return this.id === other.id;
    }
    get inCartQuantity() {
        // TODO FIXME
        return null;
    }
    get price() {
        return new PPrice(this.localizationProvider, this.domain.price)
            .dualPriceValue;
    }
}
